export default __webpack_public_path__ + "static/media/ChemicalIndustry_icon.05a197fc.svg";